import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";
import AxiosIntercepter from "../../Services/axiosIntercepter";
import {notification}  from "antd";

const getData = async (payload) => {
  const { url } = payload;
  const result = await AxiosIntercepter.get(url);
  return result;
};

const downloadpdfData = async (payload) => {
  const { url } = payload
  const result = await AxiosIntercepter.get(url)
  return result
}

const Year = async (payload) => {
  const { url } = payload
  const result = await AxiosIntercepter.get(url)
  return result
}
const handleMultipleDownloads = async (files) => {
  if (!files || !files.length) return console.error('No files to download');

  for (const file of files) {
    try {
      const response = await fetch(file);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      
      const a = document.createElement('a');
      a.href = url;
      a.download = file.split('/').pop(); // Extract file name from URL
      document.body.appendChild(a);
      a.click();

      // Cleanup
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      await new Promise((resolve) => setTimeout(resolve, 100));
    } catch (error) {
      console.error('Error downloading file:', file, error);
    }
  }
};

export function* getMyDonationsList() {
  yield takeEvery("My_DONATIONS_REQUEST", function* ({ payload }) {
    try {
      const response = yield call(getData, payload);
      if (response?.data?.status_code === 1) {
        yield put({
          type: actions.MY_DONATIONS_SUCCESS,
          myDonationsList: response.data?.data,
          successMessage: response.message,
        });
      } else {
        yield put({
          type: actions.MY_DONATIONS_ERROR,
          errorMessage: response?.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.MY_DONATIONS_ERROR,
        errorMessage: "Something went wrong. Please try after some time.",
      });
    }
  });
}

export function* downloadpdfsaga() {
  yield takeEvery(actions.DOWNLOAD_PDF_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(downloadpdfData, payload)
      if (res) {
        if(res?.data?.finalData.length<=0){
          notification.error({
            description: "No Data found",
            placement: "topRight",
          });
        }

        handleMultipleDownloads(res?.data?.finalData)
        yield put({
          type: actions.DOWNLOAD_PDF_SUCCESS,
          message: res.message,
          status_code: res.status_code,
        })
      } else {
        throw new Error('')
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_PDF_ERROR,
        payload: { error: error.message || '' },
      })
    }
  })
}



export function* getyearSaga() {
  yield takeEvery('GET_YEAR_REQUEST', function* ({ payload }) {
    try {
      const res = yield call(Year, payload)
      if (res) {
        yield put({
          type: actions.GET_YEAR_SUCCESS,
          data: res?.data?.data?.years,
        })
      }
    } catch (error) {
      yield put({
        type: actions.GET_YEAR_ERROR,
        errorMessage: 'Something went wrong. Please try after some time.',
      })
    }
  })
}

export default function* rootSaga() {
  yield all([fork(getMyDonationsList),fork(downloadpdfsaga),fork(getyearSaga)]);
}
